/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable import/prefer-default-export */
import { companyConstants } from '../constants/companyConstants';
import { companyServices } from '../services/companyServices';

function getCompany(companyId) {
  return (dispatch, getState) => {
    if (companyId) {
      dispatch(request(companyId));
      companyServices.getCompanyById(companyId)
        .then(
          (company) => {
            sessionStorage.setItem('company', JSON.stringify(company));
            dispatch(success(company));
          },
          (error) => {
            dispatch(failure(error.toString()));
          },
        );
    } else {
      dispatch(failure('No company id'));
    }
  };

  function request(company) { return { type: companyConstants.GET_COMPANY_REQUEST, company }; }
  function success(company) { return { type: companyConstants.GET_COMPANY_SUCCESS, company }; }
  function failure(error) { return { type: companyConstants.GET_COMPANY_FAILURE, error }; }
}

function unsetCompany(company) {
  return (dispatch, getState) => {
    sessionStorage.removeItem('company');
    dispatch({ type: companyConstants.UNSET_COMPANY });
  };
}

function setCompany(company) {
  return (dispatch, getState) => {
    sessionStorage.setItem('company', JSON.stringify(company));
    dispatch({ type: companyConstants.SET_COMPANY, company });
  };
}

export const companyActions = {
  getCompany,
  unsetCompany,
  setCompany,
};
